import React, { useEffect, useState } from "react";
import axios from "axios";
import DefaultImage from "../assets/img/profile.png";
import { API_URL } from "../config.js";
import LoadingSpinner from "../components/LoadingSpinner";
import { Link } from "react-router-dom";
import {
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showToast } from "../components/toast.jsx";

const DownloadPayslip = () => {
  const [profile, setProfile] = useState(null);
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPayslipData();
  }, []);

  const fetchPayslipData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setError("Authentication token not found");
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API_URL}user/salary-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setProfile(response.data.data.profile);
        setPayslips(response.data.data.payslip);
      } else {
        setError(response.data.message || "Failed to fetch payslip data");
      }
    } catch (err) {
      console.error("Error fetching payslip data:", err);
      setError("An error occurred while fetching payslip data");
    } finally {
      setLoading(false);
    }
  };

  const formatMonthYear = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${month}-${year}`;
  };

  const handleDownload = async (payslipId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `${API_URL}payroll/salary-report/download-payslip/${payslipId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      if (!response.data || response.data.size === 0) {
        showToast.error("Payslip file is empty or not available.");
        return;
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Payslip-${payslipId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      showToast.success("Payslip downloaded successfully!");
    } catch (err) {
      console.error("Error downloading payslip:", err);

      let errorMessage = "Failed to download payslip. Please try again.";
      if (err.response?.status === 404) {
        errorMessage = "Payslip not found.";
      } else if (err.response?.status === 401) {
        errorMessage = "Unauthorized access. Please login again.";
      } else if (err.response?.status === 403) {
        errorMessage = "You don't have permission to download this payslip.";
      } else if (!err.response) {
        errorMessage = "Network error. Please check your connection.";
      }

      showToast.error(errorMessage);
    }finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error)
    return (
      <div className="alert alert-danger mt-4">
        <strong>Error:</strong> {error}
      </div>
    );

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div className="profile-header">
        <div className="profile-header-cover"></div>
        <div className="profile-header-content">
          <div className="profile-header-img" style={{ verticalAlign: "middle" }}>
            <img
              src={profile?.user_image || DefaultImage}
              alt={profile?.user_fullname || ""}
              onError={(e) => (e.target.src = DefaultImage)}
            />
          </div>
          <div className="profile-header-info">
            <h4 className="m-t-sm">{profile?.user_fullname}</h4>
            <h5 className="m-t-sm">{profile?.user_designation}</h5>
            {profile?.user_code && (
              <p className="text-muted">Employee Code: {profile.user_code}</p>
            )}
          </div>
        </div>

        <ul className="profile-header-tab nav-tabs">
          <li className="nav-item">
            <Link to="/profile/change-password" className="nav-link active">
              Change Password
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/profile/edit-profile" className="nav-link active">
              Edit Profile
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/profile/Payslip" className="nav-link active">
              Download Payslip
            </Link>
          </li>
        </ul>
      </div>

      {/* Download Payslip Table Section */}
      <div className="col-md-6 mt-4">
        <div className="tab-content p-0">
          <div className="tab-pane fade in active" id="profile-about">
            <table className="table table-profile">
              <thead>
                <tr>
                  <th colSpan="2">Download Payslip</th>
                </tr>
              </thead>
              <tbody>
                {payslips && payslips.length > 0 ? (
                  payslips.map((p) => (
                    <tr key={p.id}>
                      <td className="field" style={{textAlign:"left"}}>{formatMonthYear(p.sdate)}</td>
                      <td className="value text-end">
                        <button
                          onClick={() => handleDownload(p.id)}
                          className="btn btn-link text-primary p-0"
                          title="Download Payslip"
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadPayslip;
